import { createFileRoute } from '@tanstack/react-router'
import { useEffect } from 'react'
import { useQuery } from '@tanstack/react-query'
import { Logo } from '@/components/whca/Logo'
import { MicrosoftIcon } from '@/components/whca/MicrosoftIcon'
import { ThemeToggle } from '@/components/whca/ThemeToggle'

export const Route = createFileRoute('/authentication')({
  component: Authentication,
})

async function fetchLoginURL(): Promise<string> {
  const response = await fetch('/api/login')
  const data = await response.json()
  return data.redirect_url
}

const ORG_NAME = 'WHCA Notify'

function Authentication() {
  const {
    data: loginURL,
    refetch,
    isFetching,
  } = useQuery({
    queryKey: ['loginURL'],
    queryFn: fetchLoginURL,
    enabled: false,
  })

  useEffect(() => {
    if (loginURL) {
      window.location.href = loginURL
    }
  }, [loginURL])

  return (
    <div className="relative flex h-full items-center justify-center bg-background p-6">
      <div className="absolute right-5 top-5">
        <ThemeToggle variant="pill" />
      </div>

      <div className="flex w-full max-w-[392px] flex-col items-center gap-6 rounded-[22px] border border-border bg-surface px-9 py-[42px] shadow-wha">
        <Logo size="lg" />

        <div className="text-center">
          <div className="text-[25px] font-extrabold tracking-[-0.02em]">{ORG_NAME}</div>
          <div className="mt-[7px] text-[14.5px] leading-[1.5] text-muted-foreground">
            Message groups across the Alliance —<br />
            fast, and to the right people.
          </div>
        </div>

        <button
          type="button"
          onClick={() => refetch()}
          disabled={isFetching}
          className="flex w-full items-center justify-center gap-2.5 rounded-xl bg-primary p-3.5 text-[15px] font-bold text-on-primary shadow-wha-sm transition-opacity disabled:opacity-70"
        >
          <MicrosoftIcon />
          {isFetching ? 'Redirecting…' : 'Sign in with Microsoft'}
        </button>

        <div className="text-center text-[12.5px] text-faint">
          Wellington Health Care Alliance staff only
        </div>
      </div>
    </div>
  )
}
